<template lang="pug">
  li
    f7-link(
      href="#"
      class="item-content"
      @click="$emit('click', curriculum.id)")
      .item-media
        video-thumbnail-list(:src="curriculum.video.thumbnailUrl")
      .item-inner
        .item-title-row
          .item-title(style="-webkit-box-orient: vertical;") {{ curriculum.title }}
        .item-subtitle(style="-webkit-box-orient: vertical;")
          label
            icon(name="write")
            span(class="date-with-icon") {{ dateFormat(curriculum.createdTime) }}
    f7-link(
      href="#"
      class="send-button-box"
      @click="$emit('send', curriculum.id)")
      curriculum-send-button
</template>

<style lang="scss" scoped>
li {
  position: relative;
}
.item-content {
  @extend %curriculum-list-item;

  .item-title-row {
    margin-right: 56px;
  }
}

.send-button-box {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  margin-right: 5px;
}
</style>

<script>
import VideoThumbnailList from '@/components/atoms/VideoThumbnailList'
import CurriculumSendButton from '@/components/atoms/CurriculumSendButton'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: { VideoThumbnailList, CurriculumSendButton },
  mixins: [Formatter],
  props: {
    curriculum: {
      type: Object,
      required: true,
    },
  },
}
</script>
